import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';
import { Repair } from '../models/repair.model';
import { ApplicationtTextService } from '../services/application-text.service';
import { RepairLineItemsForm, RepairLineItemsFormBulk } from '../form-model/damage-and-repair.form.model';

export function repairCodeContractValidator(repairs: Repair[], appTextSvc: ApplicationtTextService): ValidatorFn {
  return (control: AbstractControl) => {
    const damageAndRepairForm = control as FormGroup<RepairLineItemsForm | RepairLineItemsFormBulk>;
    const repairLineItems = damageAndRepairForm.controls.repairLineItems;
    if (!repairLineItems || !repairLineItems.controls) return null;
    const repaircodes = repairLineItems.getRawValue().map((x) => x.repairCode);
    for (const repairCode of repaircodes) {
      const repair = repairs.find((x) => x.code == repairCode);
      if (repair && repair.contract === 'EXPIRED') {
        return { repairCodeAndRepairLocationUnique: { value: appTextSvc.materialCostContractExpired(repairCode) } };
      }
    }
    return null;
  };
}
